import * as React from 'react'

function SvgComponent(props) {
  return (
    <svg width={1133} height={553} viewBox="0 0 1133 553" {...props}>
      <title>{'pattern'}</title>
      <g fill="none" fillRule="evenodd">
        <rect
          fill="#89BC62"
          x={386.599}
          y={386.741}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#89BC62"
          x={579.899}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#89BC62"
          x={966.499}
          y={193.37}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#C75875"
          x={579.899}
          y={386.741}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#C75875"
          x={773.199}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#C75875"
          y={193.37}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#73BEC8"
          x={579.899}
          y={193.37}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#73BEC8"
          y={386.741}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#73BEC8"
          x={193.3}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#C588C7"
          x={773.199}
          y={193.37}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#E4BA3F"
          x={193.3}
          y={386.741}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#E4BA3F"
          x={386.599}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#CB732B"
          x={773.199}
          y={386.741}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#CB732B"
          x={966.499}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#C588C7"
          x={966.499}
          y={386.741}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect fill="#C588C7" width={165.685} height={165.746} rx={7} />
        <rect
          fill="#C588C7"
          x={193.3}
          y={193.37}
          width={165.685}
          height={165.746}
          rx={7}
        />
        <rect
          fill="#CB732B"
          x={386.599}
          y={193.37}
          width={165.685}
          height={165.746}
          rx={7}
        />
      </g>
    </svg>
  )
}

export default SvgComponent
